export default __webpack_public_path__ + "static/media/delete.2614c409.svg";